import { ConfigModule } from 'shared/types'
import { controls } from 'shared/components/controls'
import { defaultLanguages } from 'shared/services/languages'

export interface GlobalConfig {
	websocketUri: string
	googleAnalytics: string
	lang: string
	theme: string
	devMode: boolean,
	appMode: boolean,
	appToolbarHeight: number,
	playAudio: boolean
	playEliminationSounds: boolean
	playPaceBoatSounds: boolean
	disableAlerts: boolean
	hideHud: boolean
	// paceraceLockScore: boolean
	remoteId: string
	route: string
	testAudioTrigger: number
	disablePreraceMessages: boolean
	disableOnboardModal: boolean
	countDownTimeCaps: boolean
	suppressAnnouncementsSeconds: number
}

import './blob'
declare module './blob' {
	interface ConfigBlob {
		global: GlobalConfig
	}
}

export const global: ConfigModule<GlobalConfig> = {
	page: '',
	panel: 'Global',
	isTheme: false,
	fields: {
		websocketUri: {
			default: 'ws://localhost:443'
		},
		googleAnalytics: {
			default: ''
		},
		lang: {
			default: 'en-US',
			control: controls.Select('Language', defaultLanguages),
			hideDuringRace: true
		},
		devMode: {
			default: false,
			private: true,
			control: controls.Checkbox('Development Mode'),
		},
		appMode: {
			default: false,
			private: true,
			control: controls.Checkbox('Show App Toolbar'),
		},
		appToolbarHeight: {
			default: 65,
			private: true,
			control: controls.Number('Toolbar Height', 1, 1, 100)
		},
		countDownTimeCaps: {
			default: true,
			control: controls.Checkbox('Count Down Time Caps'),
			private: false,
			hideDuringRace: false
		},
		playAudio: {
			default: true,
			control: controls.Checkbox('Play Audio'),
		},
		playEliminationSounds: {
			default: true,
			control: controls.Checkbox('Play Elimination Announcements'),
		},
		playPaceBoatSounds: {
			default: true,
			control: controls.Checkbox('Play Paceboat Announcements'),
		},
		suppressAnnouncementsSeconds: {
			default: 10,
			private: true,
			control: controls.Number('Suppress Announcements For (s)', 0, 1, 100)
		},
		disableAlerts: {
			default: false,
			control: controls.Checkbox('Disable Race Start Banners'),
			hideDuringRace: true
		},
		hideHud: {
			default: false,
			control: controls.Checkbox('Hide Clock & 1st Place Units'),
			private: true
		},
		// paceraceLockScore: {
		// 	default: true,
		// 	control: controls.Checkbox('Lock Score During Paceboat Race')
		// },
		theme: {
			default: 'Default',
			control: { component: 'themeSelect', label: 'Theme' },
			hideDuringRace: true
		},
		remoteId: {
			default: '',
			private: true
		},
		route: {
			default: '',
			control: controls.Select('Display', {
				Home: 'home',
				Hybrid: 'race',
				Scroll: 'scroll',
				Spectator: 'spectator',
				Participant: 'participant',
				Leaderboard: 'leaderboard',
				Summary: 'summary'
			}),
			private: false
		},
		testAudioTrigger: {
			default: 0,
			control: { component: 'testAudio', label: 'Test Audio' },
			hideDuringRace: true,
			showToParticipant: true,
			showToSpectator: true
		},
		disablePreraceMessages: {
			default: false
		},
		disableOnboardModal: {
			default: true
		}
	}
}
